import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux'
import {Button} from 'react-bootstrap';
import {translate} from '../../i18n/translate';
import {orderValidator, getCheckoutPrice} from '../../common/basket';
import {addPath} from '../../common/utils';
import {CreditTypes, NOT_USED_ALL_CREDITS_MESSAGE} from '../../common/constants';
import ModalPopup from"../../components/common/ModalPopup";
import OrderSummary from "../common/OrderSummary";
import {saveDraftOrder, setCouponAndUpdateSummary, showLoginSignupModal} from "../../actions/store/storeActions";
import styles from "../../css/store/storeOrderSummary.less";
import {setDirty} from "../../actions/common/commonActions";

class StoreOrderSummary extends React.Component {
    state = {
        couponChanged: false
    };

    validateCheckout = () => {
		if (this.props.staticData.minimumPerOrder) {
			let validationMsg = orderValidator.validateMinimumPerOrder(this.props.items,
				this.props.staticData.minimumPerOrder, this.props.extraCost, this.props.extraCostType, this.props.creditsData.credits, this.props.staticData,
                this.props.shareItems);
			if (validationMsg) {
				this.setState({popup:{
					message: validationMsg,
                    allowContinue: false
				}});
				return false;
			}
		}
		if(this.props.coupon) {
            let validationMsg = orderValidator.validateCouponMinimum(this.props.items, this.props.extraCost, this.props.extraCostType,
                this.props.creditsData.credits, this.props.staticData, this.props.activeOrder, this.props.coupon);
            if (validationMsg) {
                this.setState({popup:{
                    message: validationMsg,
                    allowContinue: true,
                    couponMinimumValidation: true
                }});
                return false;
            }
        }
		if(this.props.creditsData.remainingCredits > 0 && this.props.creditsData.creditType === CreditTypes.CREDIT_BY_SHARE) {
            let validationMsg = translate(NOT_USED_ALL_CREDITS_MESSAGE + " " +  this.props.creditItemLabel.toLocaleLowerCase());
            if (validationMsg) {
                this.setState({popup:{
                    message: validationMsg,
                    allowContinue: true
                }});
                return false;
            }
        }
		return true;
	};

    onCheckoutButtonClick = () => {
        if (this.props.memberLoggedIn) {
            if (this.validateCheckout()) {
                this.props.checkout(this.editableTotal);
            }
        } else {
            this.props.saveDraftOrderAndShowModal();
        }
	};

    onCheckoutButtonPopupClick = () => {
        this.props.checkout(this.editableTotal);
    };

    closePopup = () => {
		this.setState({popup:undefined});
	};

    checkoutAndRemoveCoupon = () => {
	    this.props.removeCouponAndUpdateSummary();
	    this.onCheckoutButtonPopupClick();
    };

    componentWillReceiveProps(nextProps) {
	    if((nextProps.coupon||{}).id !== (this.props.coupon||{}).id) {
	        this.setState({couponChanged: true});
        }
    }

    popupMessage = () => {
	    if(this.state.popup.allowContinue && this.state.popup.couponMinimumValidation) {
            return (
                <ModalPopup
                    message={translate("The changes to your order have made the coupon invalid." +
                        "</br>" + translate("To redeem the coupon, please order $") + this.props.coupon.minimumOrder  +
                        translate(" or more. Click 'Cancel' to return to the store or 'Checkout' to proceed without the coupon."))}
                    right={{text:translate('Checkout'), callback:this.checkoutAndRemoveCoupon}}
                    left={{text:translate('Cancel'), callback:this.closePopup}}/>
            );
        }
        if (this.state.popup.allowContinue)
            return (
                <ModalPopup
                    onClose={this.closePopup}
                    message={this.state.popup.message}
                    right={{text:translate('Checkout'), callback:this.onCheckoutButtonPopupClick}}
                    left={{text:translate('Back'), callback:this.closePopup}}/>
            );
        return (
            <ModalPopup
                onClose={this.closePopup}
                message={this.state.popup.message}
                middle={{text:translate('Close'), callback:this.closePopup}}/>
        );
	};

    isEnabledCheckout = () => {
	    return this.props.orderChanged || (this.props.activeOrder && this.state.couponChanged);
    };

    render() {
		if (this.state.popup) {
			return this.popupMessage();
		}
        const checkoutLabel = (this.props.staticData.storeCheckoutButtonLabel || translate(this.props.memberLoggedIn ? "Checkout" : 'Proceed')).split('|')[0];
		return (
			<div className="order-summary-container">
                <OrderSummary readonly={this.props.readonly}/>
				{this.props.readonly
					? undefined
					:
					<div className="checkout-button-wrapper">
						<Button bsStyle="primary" className="order-summary-checkout button" id="orderSummaryCheckoutButton" disabled={!this.isEnabledCheckout()}
							onClick={this.onCheckoutButtonClick}>{checkoutLabel} <span>{getCheckoutPrice(this.props.totals)}</span></Button>
					</div >

				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const summary = state.summary || {};
    const orderStatus = (state.orderStatus||{});
	return {
        staticData: state.staticData || {},
        creditsData: (state.storeCreditsData || {}),
        activeOrder: orderStatus.activeOrder,
        orderChanged: orderStatus.isChanged,
		extraCost: summary.extraCost,
		extraCostType: summary.extraCostType,
        totals: orderStatus.totals,
        coupon: orderStatus.coupon,
        creditItemLabel: state.staticData.creditItemLabel,
        memberLoggedIn: Boolean((state.memberDetails || {}).key),
        shareItems: summary.shareItems,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        saveDraftOrderAndShowModal: () => {
            dispatch(saveDraftOrder(true));
            dispatch(setDirty(false));
            dispatch(showLoginSignupModal(true));
        },
		checkout: () => {
			dispatch(push(addPath('checkout')))
		},
        removeCouponAndUpdateSummary: () => {
		    dispatch(setCouponAndUpdateSummary(undefined));
        }
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreOrderSummary);


// WEBPACK FOOTER //
// ./src/containers/store/StoreOrderSummary.js